import { Plan } from '@/types/plan';
import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface PlansState {
	plans: Plan[];
	updatePlans: (plans: Plan[]) => void;
}

const persistConfig = {
	name: 'gurupass-plans',
};

export const usePlansStore = create<PlansState>()(
	persist(
		devtools(set => ({
			plans: [],
			updatePlans: (plans: Plan[]) => set({ plans }),
		})),
		persistConfig
	)
);

if (global.window && (global.window as any).Cypress) {
	const initialState = (global.window as any).initialState;
	if (initialState) {
		usePlansStore.setState(initialState);
	}
	(window as any).plansStore = usePlansStore;
}

export default usePlansStore;
